const OtherProductId = {
  UI_MEET_3D_ACTIVE_1: 2,
  UI_MEET_3D_ACTIVE_5: 3,
  UI_MEET_3D_ACTIVE_12: 4,
  UI_MEET_3D_ACTIVE_50: 5,
  UI_MEET_3D_UNLIMITED: 6,
};

export default OtherProductId;
